import accountApi from "./api/AccountApi";
import globalSearchApi from "./api/GlobalSearchApi";
import { ConditionalElement } from "./components/ConditionalElement";
import MemberAvatar from "./components/MemberAvatar";
import { initializeSelectAll } from "./features/select-all-checkbox";
import { translationService } from "./i18n/TranslationsService";
import { initializeTranslations } from "./i18n/translate";
import { initializeArticleListing } from "./pages/ArticleListingPage";
import { globalSearchService } from "./services/GlobalSearchService";
import languageService from "./services/LanguageService";
import { initializeSiteSearch } from "./components/SiteSearch";
import { initializeSearchResultsPage } from "./pages/SearchResultsPage";
import { onDomReady } from "./common/DomUtils";
import { initializeContactWithAuthor } from "./pages/ContactWithAuthorController";


function registerApis() {
    if (!window.pwcStudio)
        window.pwcStudio = {};
    window.pwcStudio.accountApi = accountApi;
    window.pwcStudio.globalSearchApi = globalSearchApi;
}

function registerServices() {
    window.pwcStudio.languageService = languageService;
    window.pwcStudio.globalSearchService = globalSearchService;
    window.pwcStudio.translationService = translationService;
}

function registerComponents() {
    const initializeComponents = () => {
        const avatarElements = document.querySelectorAll('.pwc-studio-js-member-avatar');
        avatarElements.forEach(element => {
          const picUrl = element.getAttribute('data-pic-url') || undefined;
          new MemberAvatar(element as HTMLElement, accountApi, { picUrl: picUrl });
        });

        const conditionalElements = document.querySelectorAll('.pwc-studio-js-conditional-element');
        conditionalElements.forEach(element =>  new ConditionalElement(element as HTMLElement));
        
        document.querySelectorAll(".dropdown-item[data-lang]").forEach(item => {
          item.addEventListener("click", (e) => {
              e.preventDefault();
              const lang = item.getAttribute("data-lang");
              if (lang) {
                  languageService.setCurrent(lang);
                  window.location.reload();
              }
          });
        });

        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
              mutation.addedNodes.forEach(node => {
                if (node instanceof HTMLElement && node.classList.contains('pwc-studio-js-conditional-element')) {
                  new ConditionalElement(node);
                } 
              });
            });
          });
        
          observer.observe(document.body, { 
            childList: true,
            subtree: true
          });

          initializeSiteSearch();
    };

    onDomReady(initializeComponents);
}

function registerPages() {
  const initializePages = () => {
    const isGlobalSearchResultsPage = !!document.querySelector("#pwcstudio-searchresults-header");
    if (!isGlobalSearchResultsPage) {
      initializeArticleListing();
    }
    initializeSelectAll();
    initializeContactWithAuthor();
  };

  onDomReady(initializePages);
  initializeSearchResultsPage();
}

(function() {
    (async () => {
        registerApis();
        registerServices();
        await initializeTranslations();
        registerComponents();
        registerPages();
    })();
})();